<template>
  <div>
    <qs-drawer
      title="线索管理配置"
      cusType="group"
      cusSize="xl"
      :visible.sync="drawerVisible"
      :before-close="cancel"
      class="edit-strategy-drawer">
      <card v-if="!saveSuccess" class="step-card">
        <el-steps :active="currentStep" align-center class="clue-steps">
          <el-step title="基础信息"></el-step>
          <el-step title="回收配置"></el-step>
        </el-steps>
      </card>
      <card v-else class="step-card success-card">
        <div class="success-text"><i class="el-icon-success"></i><span class="text">已完成</span></div>
        <span>线索配置完成</span>
      </card>
      <!-- 基础信息 -->
      <div v-show="currentStep === CURRENT_STEP_ENUM.STEP_ONE && !saveSuccess" class="step-container">
        <card>
          <el-form
            ref="storeFormRef"
            :model="storeForm"
            :rules="storeFormRules"
            class="vertical-form-box">
            <el-row :gutter="32">
              <el-col :span="12">
                <el-form-item label="所属门店" prop="storeId">
                  <template v-if="isEdit">
                    {{ storeForm.storeName || '' }}
                  </template>
                  <QS-select
                    v-else
                    v-model="storeForm.storeId"
                    :optionData="storeOptionList"
                    :optionConfig="{labelKey: 'name', valueKey: 'id'}"
                    filterable>
                  </QS-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="销售管理者" prop="employeeIdList">
                  <div slot="label">
                    <span>销售管理者</span>
                    <el-popover
                      placement="right-end"
                      title="温馨提示"
                      width="320"
                      trigger="hover"
                      content="该人员可查看门店下所有的线索及数据看板"
                    >
                      <i
                        slot="reference"
                        class="el-icon-question"
                        style="color: #c8c9cc; font-size: 16px; padding-right: 3px;"
                      />
                    </el-popover>
                  </div>
                  <QS-select
                    v-model="storeForm.employeeIdList"
                    :optionData="employeeOptionList"
                    :optionConfig="{labelKey: 'userName', valueKey: 'id'}"
                    multiple
                    filterable>
                  </QS-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </card>
        <card class="sales-config-card">
          <div slot="custom-header">
            <p class="title">
              <span class="required">*</span>
              销售人员配置
              <el-popover
                placement="right-end"
                title="温馨提示"
                width="320"
                trigger="hover"
                content="配置的销售人员可在线索大厅获取线索并跟进"
              >
                <i
                  slot="reference"
                  class="el-icon-question"
                  style="color: #c8c9cc; font-size: 16px; margin-left: 3px; margin-top: 8px;"
                />
              </el-popover>
            </p>
          </div>
          <el-transfer
            v-model="transferConfig.rightList"
            :data="transferConfig.leftList"
            :props="{
              key: 'id',
              label: 'userName'
            }"
            :titles="['未选择人员', '已选择人员']"
            filterable
            class="user-transfer">
            <template #default="{ option }">
              <div class="user-info">
                <div class="user-info-top">
                  <span class="name">{{ option.userName }}</span>
                  <el-tag v-if="showDisabledTag(option)" type="danger" size="small">禁用</el-tag>
                </div>
                <span class="dept">所属部门：{{ option.deptName }}</span>
              </div>
            </template>
          </el-transfer>
        </card>
      </div>
      <!-- 回收配置 -->
      <div v-show="currentStep === CURRENT_STEP_ENUM.STEP_TWO && !saveSuccess" class="step-container">
        <card>
          <div class="rules-box">
            <p class="rule-title">
              线索回收配置
            </p>
            <el-alert
              title="温馨提示"
              type="info"
              :closable="false"
              style="margin-bottom: 20px;">
              <div>
                <p>1. 首次跟进需在6小时内完成，否则线索将被回收</p>
                <p>2. 建议跟进频率至少保持2天1次，否则线索将被回收</p>
                <p>3. 特殊节假日（元旦、春节、清明节、劳动节、端午节、国庆节、中秋节）期间线索不进行回收</p>
              </div>
            </el-alert>
            <el-form
              :model="configForm"
              :rules="configRules"
              ref="configFormRef">
              <div class="rule-item">
                <span>规则1：首次跟进需在</span>
                <el-form-item prop="firstTimeOut">
                  <el-select
                    v-model.number="configForm.firstTimeOut"
                  >
                    <el-option
                      v-for="item in 6"
                      :key="item"
                      :label="item"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
                <span>小时内完成</span>
              </div>
              <div class="rule-item">
                <span>规则2：跟进频率</span>
                <el-form-item prop="frequencyDay">
                  <el-input
                    v-model="configForm.frequencyDay"
                    placeholder="请输入"
                    v-integerNumber="{
                      min: 1,
                      max: 30
                    }"
                    @input="frequencyDayChange"
                    ></el-input>
                </el-form-item>
                <span>天内需跟进</span>
                <el-form-item prop="frequencyNum">
                  <el-input
                    v-model.number="configForm.frequencyNum"
                    placeholder="请输入"
                    v-integerNumber="{
                      min: 1,
                      max: 50
                    }"></el-input>
                </el-form-item>
                <span>次</span>
              </div>
            </el-form>
          </div>
        </card>
      </div>
      <div v-show="saveSuccess" class="step-container">
        <card class="wx-img">
          <el-image
            class="img"
            :src="CLUE_HALL_QRCODE"
          />
          <div class="content">微信扫码，在小程序【线索大厅】领取线索</div>
        </card>

      </div>
      <template #footer>
        <template v-if="!saveSuccess">
          <el-button @click="cancel">取消</el-button>
          <template v-if="currentStep === CURRENT_STEP_ENUM.STEP_TWO">
            <el-button @click="handlePrev">上一步</el-button>
            <el-button type="primary" :loading="submitLoading" @click="submit">保存配置</el-button>
          </template>
          <el-button
            v-else-if="currentStep === CURRENT_STEP_ENUM.STEP_ONE"
            @click="handleNext"
            type="primary">下一步</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="cancel">关闭</el-button>
        </template>
      </template>
    </qs-drawer>
    <!--线索转移的dialog-->
    <el-dialog
      title="线索转移提醒"
      :visible.sync="dialogVisible"
      custom-class="m-dialog"
    >
      <div>
        <p class="transfer-clue">{{ dialogContent.peopleHasClue }}有线索需转移</p>
        <div>
          <span>转移至</span>
          <el-select v-model="dialogContent.transferId">
            <el-option
              v-for="(item, index) of dialogContent.transferList"
              :key="`${item.id}${index}`"
              :label="item.userName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="() => saveData(true)">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, reactive } from 'vue'
import {
  storeClueConfigCheck,
  storeClueConfigSave,
  storeClueConfigDetail,
} from '@/api/clueAPI'
import { Message } from '@qs/ui'
import { use$to, useSubmitLock } from '@/utils/useUtils'
import { getAllEmployeeList } from '@/api/carManage/index.js'
import { storeList } from '@/api/domain/shop.js'
import { CLUE_HALL_QRCODE } from '@/config'

const $to = use$to()

const { loading: submitLoading, run } = useSubmitLock()
// 员工状态枚举，1-启用，0-禁用
const EMPLOYEE_STATE_ENUM = {
  ENABLE: 1,
  DISABLED: 0,
}
// 当前步骤枚举
const CURRENT_STEP_ENUM = {
  STEP_ONE: 0,
  STEP_TWO: 1,
}
// 回收配置默认配置
const DEFAULT_RULE_INFO = {
  firstTimeOut: 6, // 首次跟进超时，默认6小时
  frequencyDay: 6, // 跟进频率天数 默认6天
  frequencyNum: 3, // 跟进频率次数，默认3次
}
// 当前步骤
const currentStep = ref(CURRENT_STEP_ENUM.STEP_ONE)
const drawerVisible = ref(false)
// 线索转移的dialog
const dialogVisible = ref(false)
// 线索转移dialog的内容
const dialogContent = reactive({
  peopleHasClue: '', // 离职人员
  transferList: [], // 转移到的人员列表
  transferId: null,
})
// 线索策略详情
const detailInfo = ref({})
// 穿梭框数据配置
const transferConfig = ref({
  leftList: [],
  rightList: [],
})
// 门店列表
const storeOptionList = ref([])
// 公司员工列表
const employeeOptionList = ref([])
// 策略配置表单
const configForm = ref({
  ...DEFAULT_RULE_INFO,
})
// 策略配置表单ref
const configFormRef = ref(null)
// 门店相关配置表单
const storeForm = ref({
  storeId: '',
  employeeIdList: [],
})
const isEdit = ref(false)
// 门店相关配置表单ref
const storeFormRef = ref(null)
// 策略保存成功
const saveSuccess = ref(false)

// 校验跟进频率次数
const validateFrequencyNum = (rule, value, callback) => {
  if (!value || value === '0') return callback(new Error('请输入跟进频率次数'))
  if (!configForm.value.frequencyDay) return callback()
  configFormRef.value.clearValidate('frequencyDay')
  if (Number(configForm.value.frequencyDay) / Number(value) > 2) {
    return callback(new Error('请至少保持2天/次的跟进频率'))
  }
  return callback()
}
const storeFormRules = {
  storeId: [
    { required: true, message: '请选择所属门店', trigger: 'change' },
  ],
}
const configRules = {
  firstTimeOut: [
    { required: true, message: '请输入首次跟进超时', trigger: 'blur' },
  ],
  frequencyDay: [
    { required: true, message: '请输入跟进频率天数', trigger: 'blur' },
  ],
  frequencyNum: [
    { required: true, type: 'number', message: '请输入跟进频率次数', trigger: 'blur' },
    { type: 'number', max: 50, message: '最大值不超过50', trigger: 'blur' },
    { type: 'number', validator: validateFrequencyNum, trigger: 'blur' },
  ],
}

const emit = defineEmits(['refreshTable'])
const frequencyDayChange = () => {
  configFormRef.value.validateField('frequencyNum')
}
const showDrawer = (row) => {
  saveSuccess.value = false
  drawerVisible.value = true
  currentStep.value = CURRENT_STEP_ENUM.STEP_ONE
  storeForm.value = {
    storeId: '',
    employeeIdList: [],
  }
  transferConfig.value.rightList = []
  dialogContent.transferId = null
  isEdit.value = false
  configForm.value = {
    firstTimeOut: DEFAULT_RULE_INFO.firstTimeOut,
    frequencyDay: DEFAULT_RULE_INFO.frequencyDay,
    frequencyNum: DEFAULT_RULE_INFO.frequencyNum,
  }
  if (row) {
    getDetail(row.storeId)
    isEdit.value = true
  }
  getStoreList()
  getEmployeeList()
  getEmployeeListWithDisabled()
}

// 获取门店列表
const getStoreList = async () => {
  const [err, res] = await $to(
    storeList({
      pageNum: 1,
      pageSize: 9999,
      filterConfiguredStore: true,
    }),
  )
  if (err || res?.code !== 1 || !res?.data) {
    return
  }
  storeOptionList.value = res.data.items || []
}
// 获取员工列表,只有启用的
const getEmployeeList = async () => {
  const [err, res] = await $to(
    getAllEmployeeList(),
  )
  if (err || res?.code !== 1 || !res?.data) {
    return
  }
  employeeOptionList.value = res.data
}
// 获取公司下所有员工列表，包含禁用的
const getEmployeeListWithDisabled = async () => {
  const [err, res] = await $to(
    getAllEmployeeList({ includeDisabled: 'YES' }),
  )
  if (err || res?.code !== 1 || !res?.data) {
    return
  }
  transferConfig.value.leftList = res.data
}
// 获取线索配置详情
const getDetail = async (id) => {
  const [err, res] = await $to(
    storeClueConfigDetail({
      storeId: id,
    }),
  )
  if (err || res?.code !== 1 || !res?.data) {
    return
  }
  detailInfo.value = { ...res.data }
  const { ruleInfo, storeId, storeName, managerList, selectedEmployeeList } = res.data
  configForm.value = {
    firstTimeOut: ruleInfo?.firstTimeOut || DEFAULT_RULE_INFO.firstTimeOut,
    frequencyDay: ruleInfo?.frequencyDay || DEFAULT_RULE_INFO.frequencyDay,
    frequencyNum: ruleInfo?.frequencyNum || DEFAULT_RULE_INFO.frequencyNum,
  }
  storeForm.value = {
    storeId: Number(storeId),
    storeName,
    employeeIdList: managerList?.map((item) => item.userId) || [],
  }
  transferConfig.value.rightList = selectedEmployeeList?.map((item) => item.userId) || []
}

const cancel = () => {
  drawerVisible.value = false
  employeeOptionList.value = []
  if (saveSuccess.value) {
    emit('refreshTable')
    currentStep.value = CURRENT_STEP_ENUM.STEP_ONE
  }
}

const submit = () => {
  configFormRef.value.validate((valid) => {
    if (!valid) return
    run(saveData)
  })
}

// 销售人员校验
const dataCheck = async () => {
  const params = {
    storeId: storeForm.value.storeId,
    employeeIdList: transferConfig.value.rightList || [],
  }
  if (!isEdit.value) {
    params.operateType = 1
  }
  if (params.employeeIdList.length === 0) {
    Message.error('请至少配置一个销售人员')
    return
  }
  const [err, res] = await $to(
    storeClueConfigCheck(params),
  )
  // 有销售人员属于其他门店
  if (err || res?.code !== 1) {
    return false
  }
  // 有离职人员线索未分配
  if (Array.isArray(res.data) && res.data.length > 0) {
    dialogContent.peopleHasClue = res.data.map((item) => item.userName).join('、')
    // 销售管理人员和右侧选中的销售人员的合集，销售管理者在前
    const userIdSet = new Set()
    // 获取销售管理者列表
    const temp = []
    storeForm.value.employeeIdList.forEach((id) => {
      // 判断选中的销售管理者是否启用，只有启用状态才会显示在转移下拉列表
      const tempEmployeeItem = employeeOptionList.value.find((item) => item.id === id)
      // 如果被删除的销售人员同时是销售管理者，那么转移人员列表不应该添加他
      const deleteEmployeeItem = res.data.find((item) => item.userId === id)
      if (tempEmployeeItem && !deleteEmployeeItem) {
        temp.push(tempEmployeeItem)
        userIdSet.add(id)
      }
    })
    for (const id of transferConfig.value.rightList) {
      if (userIdSet.has(id)) continue
      const tempItem = transferConfig.value.leftList.find((item) => item.id === id)
      if (tempItem) {
        temp.push(tempItem)
      }
      userIdSet.add(id)
    }
    dialogContent.transferList = temp
    dialogContent.transferId = dialogContent.transferList[0]?.id
    dialogVisible.value = true
  }
  // 校验通过
  if (!res.data) return true
}

// 保存线索配置的数据
const saveData = async (flag = false) => {
  if (flag && !dialogContent.transferId) {
    Message.error('请选择线索转移的负责人')
    return
  }
  if (currentStep.value === CURRENT_STEP_ENUM.STEP_ONE) {
    currentStep.value++
    dialogVisible.value = false
    return
  }
  // 保存数据接口
  const postData = {
    storeId: storeForm.value.storeId,
    managerIdList: storeForm.value.employeeIdList,
    employeeIdList: transferConfig.value.rightList,
    ruleInfo: configForm.value,
  }
  if (dialogContent.transferId) {
    postData.transferId = dialogContent.transferId
    // 需要将选择的转移人员（针对的是销售管理者）加入到销售人员列表，这时一个销售人员可以属于多个门店，所以一个销售人员只能属于一个门店的限制在这次优化放开
    const tempSet = new Set(transferConfig.value.rightList)
    tempSet.add(dialogContent.transferId)
    postData.employeeIdList = Array.from(tempSet)
  }
  if (!isEdit.value) {
    postData.operateType = 1
  }
  const [err, res] = await $to(
    storeClueConfigSave(postData),
  )
  if (err || res?.code !== 1 || !res?.data) {
    return
  }
  saveSuccess.value = true
}

const handleNext = () => {
  storeFormRef.value.validate(async (valid) => {
    if (!valid) return
    const checkRes = await dataCheck()
    if (!checkRes) return
    if (currentStep.value === CURRENT_STEP_ENUM.STEP_ONE) {
      currentStep.value++
    }
  })
}

const handlePrev = () => {
  if (currentStep.value === CURRENT_STEP_ENUM.STEP_TWO) {
    currentStep.value--
  }
}
// 被禁用员工是否展示禁用tag
const showDisabledTag = (option) => {
  return option.state === EMPLOYEE_STATE_ENUM.DISABLED
}
defineExpose({
  showDrawer,
})
</script>
<style lang="scss" scoped>
.edit-strategy-drawer {
  ::v-deep .el-drawer__body {
    overflow-y: hidden;
  }
  .step-card {
    position: absolute;
    width: auto;
    left: 16px;
    right: 16px;
    height: 130px;
    display: flex;
    align-items: center;
    .clue-steps {
      width: 100%;
    }
  }
  .step-container {
    margin-top: 138px;
    height: calc(100% - 138px);
    overflow-y: auto;
  }
}
.base-info {
  color: #333;
}
.rules-box {
  background-color: #f9fafb;
  border-radius: 8px;
  padding: 8px;
  color: #333;
  margin-bottom: 10px;
  .rule-title {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin: 0 0 12px 0;
    display: flex;
    align-items: center;
    .el-icon-question {
      vertical-align: text-bottom;
      margin-left: 3px;
    }
  }
  ::v-deep .rule-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .el-form-item {
      margin-bottom: 0;
      margin: 0 8px;
      width: 100px;
      .el-form-item__error {
        white-space: nowrap;
      }
    }
  }
}
.sales-config-card {
  .title {
    justify-content: flex-start !important;
    .required {
      color: #FF5964;
      margin-right: 4px;
      justify-content: flex-start;
    }
  }
}
.user-transfer {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  ::v-deep .el-transfer-panel {
    width: 331px;
  }
  ::v-deep .el-transfer-panel__item {
    height: auto;
    .el-checkbox__input {
      top: 4px;
    }
    .user-info {
      display: flex;
      flex-direction: column;
      .user-info-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .name {
        color: rgba(0, 0, 0, 0.9);
        line-height: 24px;
        font-weight: 500;
      }
      .dept {
        color: rgba(0, 0, 0, 0.6);
        font-size: 12px;
        line-height: 24px;
      }
    }
  }
}
.success-card {
  height: 130px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  .success-text {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    .el-icon-success {
      color: #14CC52;
      font-size: 24px;
      margin-right: 4px;
    }
    .text {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.9);
    }
  }
}
.wx-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0 80px;
  .img {
    width: 220px;
    height: auto;
  }
  .content {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.9);
    margin-top: 16px;
  }
}
</style>
<style lang="scss">
.m-dialog {
  width: 560px;
  .transfer-clue {
    margin: 0 0 12px 0;
  }
  .el-dialog__body {
    max-height: calc(70vh - 144px) !important;
    min-height: calc(20vh - 108px);
    overflow-y: hidden;
  }
}
</style>
